import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const DELETE_OFFER_TEMPLATE_PDF_MUTATION = gql`
  mutation deleteOfferTemplatePdf($data: DeleteOfferTemplatePdfInput!) {
    deleteOfferTemplatePdf(data: $data) { response }
  }
`;

@Injectable({ providedIn: 'root' })
export class DeleteOfferTemplatePdfMutation extends Mutation<RootMutation> {
  document = DELETE_OFFER_TEMPLATE_PDF_MUTATION;
}
